<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-print-none">
      <div class="float-end pb-2">
        <a
          href="javascript:window.print()"
          class="btn btn-primary waves-effect waves-light me-1"
          ><i class="fa fa-print"></i> Print Reports</a>

        <!-- <b-button @click="sendReportEmail" class="me-1">
            <i class="fas fa-envelope"></i> Email Report
            <b-spinner v-if="isLoadingmail" small label="Small Spinner"></b-spinner>
        </b-button> -->

<!--          <b-button variant="success" @click="sendWhatsApp">-->
<!--              <i class="fab fa-whatsapp"></i> Send Report-->
<!--              <b-spinner v-if="isLoadingmessage" small label="Small Spinner"></b-spinner>-->
<!--          </b-button>-->
      </div>

      <!-- EMAIL MODEL -->
      <b-modal
        id="email_report"
        :title="`Email Lab results report to ${SingleResult[0].patient_name}`"
        hide-footer
      >
        <div
          v-if="!SingleResult[0].patient_email"
          class="alert alert-warning d-flex align-items-center"
          role="alert"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
            viewBox="0 0 16 16"
            role="img"
            aria-label="Warning:"
          >
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
            />
          </svg>
          <div>This client has no email, please enter client email below</div>
        </div>
        <div class="form-group" v-if="!SingleResult[0].patient_email">
          <label>Email</label>
          <input type="email" class="form-control" placeholder="Enter client email" />
        </div>

        <div v-else class="alert alert-warning d-flex align-items-center" role="alert">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="20"
            fill="currentColor"
            class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
            viewBox="0 0 16 16"
            role="img"
            aria-label="Warning:"
          >
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
            />
          </svg>
          <div>
            You are about to send a result report email to client
            <b>{{ SingleResult[0].patient_name }}</b> on
            <b>{{ SingleResult[0].patient_email }}</b>
          </div>
        </div>
        <br />
        <div class="modal-footer">
          <button
            @click="closeMode('email_report')"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>
          <button type="button" class="btn btn-primary" @click="sendReportEmail()">
            Send Email
            <b-spinner
              v-if="SingleEmailStatus"
              class="m-0"
              style="float: right"
              small
              variant="light"
              role="status"
            ></b-spinner>
          </button>
        </div>
      </b-modal>

      <!-- END EMAIL MODEL -->
    </div>
    <div class="d-print-none">
      <button @click="$router.go(-1)" class="btn btn-success">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <hr>
    <div class="row print">
      <div class="col-12">
        <div class="card p-2">
          <div class="card-body">
            <div>
              <div style="width: 100%; top: 0; height: 130px">
                <div style="width: 50%; float: left; top: 0px">
                  <img :src="SingleResult[0].clinic_logo" alt="Logo" height="100" />
                </div>
                <div style="width: 50%; float: right; top: -3px">
                  <h5 class="text-uppercase text-end">
                    <strong>{{ SingleResult[0].clinic_name }}</strong>
                  </h5>
                  <table align="right" width="100%">
                    <tr align="right">
                      <td v-html="SingleResult[0].clinic_address"></td>
                    </tr>
                    <tr align="right">
                      <td>
                        <strong>Tel:</strong>
                        +{{ SingleResult[0].clinic_contact }}
                      </td>
                    </tr>
                    <tr align="right">
                      <td>
                        <strong>Email:</strong>
                        {{ SingleResult[0].clinic_email }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div style="text-align: center">
                <h5 class="text-decoration-underline">
                  <strong>FINAL LABORATORY REPORT</strong>
                </h5>
              </div>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Patient Name:</td>
                    <td>
                      <b v-if="SingleResult[0].spouse"
                        >{{ SingleResult[0].spouse.spouse_name
                        }}<sup>{{ SingleResult[0].patient_name }}'s spouse</sup></b
                      >
                      <b v-else>{{ SingleResult[0].patient_name }}</b>
                    </td>
                    <td>Patient Id:</td>
                    <td>
                      <b>{{ SingleResult[0].patient_code }}</b>
                    </td>
                  </tr>
                  <tr v-show="SingleResult[0].age || SingleResult[0].gender">
                    <td v-show="SingleResult[0].gender">Gender</td>
                    <td v-show="SingleResult[0].gender">
                      <b v-if="SingleResult[0].gender == 1">Male</b>
                      <b v-else>Female</b>
                    </td>
                    <td v-show="SingleResult[0].age">Age:</td>
                    <td v-show="SingleResult[0].age">
                      <b>{{ SingleResult[0].age }}</b>

                      <span v-if="SingleResult[0].age_unit == 1">Years</span>
                      <span v-else-if="SingleResult[0].age_unit == 2">Months</span>
                      <span v-else-if="SingleResult[0].age_unit == 3">Days</span>
                      <span v-else>--</span>
                    </td>
                  </tr>
                  <tr
                    v-show="
                      SingleResult[0].patient_village ||
                      SingleResult[0].patient_contact ||
                      SingleResult[0].spouse
                    "
                  >
                    <td
                      v-show="SingleResult[0].patient_contact || SingleResult[0].spouse"
                    >
                      Patient Contact:
                    </td>
                    <td
                      v-show="SingleResult[0].patient_contact || SingleResult[0].spouse"
                    >
                      <b v-if="SingleResult[0].spouse">{{
                        SingleResult[0].spouse.spouse_contact
                      }}</b>
                      <b v-else>{{ SingleResult[0].patient_contact }}</b>
                    </td>
                    <td v-show="SingleResult[0].patient_village">Patient's Village:</td>
                    <td v-show="SingleResult[0].patient_village">
                      <b>{{ SingleResult[0].patient_village }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td v-show="SingleResult[0].temperature">Temperature:</td>
                    <td v-show="SingleResult[0].temperature">
                      <b>{{ SingleResult[0].temperature }} &#8451;</b>
                    </td>
                    <td v-show="SingleResult[0].pressure">Pressure:</td>
                    <td v-show="SingleResult[0].pressure">
                      <b>{{ SingleResult[0].pressure }} mmHg</b>
                    </td>
                  </tr>
                  <tr>
                      <td v-show="SingleResult[0].temperature">Weight:</td>
                      <td v-show="SingleResult[0].weight">
                          <b>{{ SingleResult[0].weight }} KG</b>
                      </td>
                      <td v-show="SingleResult[0].height">Height:</td>
                      <td v-show="SingleResult[0].height">
                          <b>{{ SingleResult[0].height }} CM</b>
                      </td>
                  </tr>
                  <tr>
                    <td>Facility:</td>
                    <td>
                      <b>{{ SingleResult[0].facility }}</b>
                    </td>
                    <td>Print Date:</td>
                    <td>
                      <b>{{ SingleResult[0].print_date }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="SingleResult[0].result_type == 1">
                <p
                  style="font-size: 12px"
                  class="text-decoration-underline"
                  v-if="SingleResult[0].samples.length"
                >
                  Test Samples
                </p>
                <table
                  style="margin-top: -10px"
                  width="100%"
                  v-if="SingleResult[0].samples.length"
                >
                  <thead>
                    <th>SAMPLE TYPE</th>
                    <th>DATE COLLECTED</th>
                    <th>DATE RECEIVED</th>
                    <th>TEST REQUESTED</th>
                  </thead>
                  <tbody>
                    <tr v-for="(sample, s) in SingleResult[0].samples" :key="s">
                      <td>{{ sample.sample_name }}</td>
                      <td>{{ sample.pick_time }}</td>
                      <td>{{ sample.receive_time }}</td>
                      <td>{{ sample.test_name }}</td>
                    </tr>
                  </tbody>
                </table>
                <!--                <hr />-->
                <p style="font-size: 13px" class="text-decoration-underline">
                  Test Results
                </p>
                <p>
                  Test Done:
                  <strong>{{ SingleResult[0].test }}</strong>
                </p>
                <p>
                  Test Result:
                  <strong>{{ SingleResult[0].resultoptions[0].option_name }}</strong>
                </p>
                <p>
                  Test Comments:
                  <strong v-html="SingleResult[0].comment"></strong>
                </p>
                <div>
                  <p style="font-size: 11px">
                    Performed By:
                    <strong>{{ SingleResult[0].technician }}</strong>
                    Result Entry Date:
                    <strong>{{ SingleResult[0].result_date }}</strong>
                  </p>
                  <p v-if="SingleResult[0].reviewer">
                    Reviewed By:
                    <strong>{{ SingleResult[0].reviewer }}</strong>
                    Date Reviewed:
                    <strong>{{ SingleResult[0].review_date }}</strong>
                  </p>
                </div>
                <!--                <hr />-->
                <div>
                  <div style="text-align: center; font-size: 11px">
                    <p>
                      Report Printed by <b>{{ SingleResult[0].printuser }}</b> via Clinic
                      Plus Hospital Software
                    </p>
                  </div>
                </div>
                <div class="image" v-if="SingleResult[0].clinic_stamp">
                  <img :src="SingleResult[0].clinic_stamp" alt="stamp" />
                  <div class="stamp_date">{{ SingleResult[0].date }}</div>
                </div>
              </div>
              <div v-else-if="SingleResult[0].result_type == 2">
                <div
                  class="text-uppercase text-center text-decoration-underline font-weight-semibold"
                >
                  {{ SingleResult[0].test }} test results
                </div>
                <p
                  style="font-size: 12px"
                  class="text-decoration-underline"
                  v-show="SingleResult[0].samples.length"
                >
                  Test Samples
                </p>
                <table width="100%" v-show="SingleResult[0].samples.length">
                  <thead>
                    <th>SAMPLE TYPE</th>
                    <th>DATE COLLECTED</th>
                    <th>DATE RECEIVED</th>
                    <th>TEST REQUESTED</th>
                  </thead>
                  <tbody>
                    <tr v-for="(sample, s) in SingleResult[0].samples" :key="s">
                      <td>{{ sample.sample_name }}</td>
                      <td>{{ sample.pick_time }}</td>
                      <td>{{ sample.receive_time }}</td>
                      <td>{{ sample.test_name }}</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  Test: <strong>{{ SingleResult[0].resultoptions.labtest.name }}</strong>
                </p>
                <div v-if="SingleResult[0].comment">
                  <p style="font-size: 13px">Comments:</p>
                  <article v-html="SingleResult[0].comment"></article>
                </div>
                <div style="font-size: 11px">
                  <p>
                    Performed By:
                    <strong>{{ SingleResult[0].technician }}</strong>
                    Result Entry Date:
                    <strong>{{ SingleResult[0].result_date }}</strong>
                  </p>
                  <p v-if="SingleResult[0].reviewer">
                    Reviewed By:
                    <strong>{{ SingleResult[0].reviewer }}</strong>
                    Date Reviewed:
                    <strong>{{ SingleResult[0].review_date }}</strong>
                  </p>
                </div>
                <!--                <hr />-->
                <div>
                  <div style="text-align: center; font-size: 11px">
                    <p>
                      Report Printed by <b>{{ SingleResult[0].printuser }}</b> via Clinic
                      Plus Hospital Software
                    </p>
                  </div>
                </div>
                <div class="image" v-if="SingleResult[0].clinic_stamp">
                  <img :src="SingleResult[0].clinic_stamp" alt="stamp" />
                  <div class="stamp_date">{{ SingleResult[0].date }}</div>
                </div>
              </div>
              <div v-else-if="SingleResult[0].result_type == 3">
                <div
                  class="text-uppercase text-center text-decoration-underline font-weight-semibold"
                >
                  {{ SingleResult[0].test }} test results
                </div>
                <!--                <hr v-show="SingleResult[0].samples.length"/>-->
                <p
                  style="font-size: 12px"
                  class="text-decoration-underline"
                  v-show="SingleResult[0].samples.length"
                >
                  Test Samples
                </p>
                <table width="100%" v-show="SingleResult[0].samples.length">
                  <thead>
                    <th>SAMPLE TYPE</th>
                    <th>DATE COLLECTED</th>
                    <th>DATE RECEIVED</th>
                    <th>TEST REQUESTED</th>
                  </thead>
                  <tbody>
                    <tr v-for="(sample, s) in SingleResult[0].samples" :key="s">
                      <td>{{ sample.sample_name }}</td>
                      <td>{{ sample.pick_time }}</td>
                      <td>{{ sample.receive_time }}</td>
                      <td>{{ sample.test_name }}</td>
                    </tr>
                  </tbody>
                </table>
                <!--                <hr />-->
                <p>
                  Test: <strong>{{ SingleResult[0].resultoptions.labtest.name }}</strong>
                </p>
                <div v-if="SingleResult[0].comment">
                  <p style="font-size: 13px">Comments:</p>
                  <article v-html="SingleResult[0].comment"></article>
                </div>
                <div style="font-size: 11px">
                  <p>
                    Performed By:
                    <strong>{{ SingleResult[0].technician }}</strong>
                    Result Entry Date:
                    <strong>{{ SingleResult[0].result_date }}</strong>
                  </p>
                  <p v-if="SingleResult[0].reviewer">
                    Reviewed By:
                    <strong>{{ SingleResult[0].reviewer }}</strong>
                    Date Reviewed:
                    <strong>{{ SingleResult[0].review_date }}</strong>
                  </p>
                </div>
                <!--                <hr />-->
                <div>
                  <div style="text-align: center; font-size: 11px">
                    <p>
                      Report Printed by <b>{{ SingleResult[0].printuser }}</b> via Clinic
                      Plus Hospital Software
                    </p>
                  </div>
                </div>
                <div class="image" v-if="SingleResult[0].clinic_stamp">
                  <img :src="SingleResult[0].clinic_stamp" alt="stamp" />
                  <div class="stamp_date">{{ SingleResult[0].date }}</div>
                </div>
              </div>
              <div v-else-if="SingleResult[0].result_type == 4">
                <p style="font-size: 12px" class="text-decoration-underline">
                  Test Samples
                </p>
                <table class="table">
                  <thead>
                    <tr>
                      <th>SAMPLE TYPE</th>
                      <th>DATE COLLECTED</th>
                      <th>DATE RECEIVED</th>
                      <th>TEST REQUESTED</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sample, s) in SingleResult[0].samples" :key="s">
                      <td>{{ sample.sample_name }}</td>
                      <td>{{ sample.pick_time }}</td>
                      <td>{{ sample.receive_time }}</td>
                      <td>{{ sample.test_name }}</td>
                    </tr>
                  </tbody>
                </table>
                <!--                <hr />-->
                <p style="font-size: 13px" class="text-decoration-underline">
                  Test Results
                </p>
                <table class="table table-bordered">
                  <thead>
                    <th>Parameter</th>
                    <th>Result</th>
                    <th>Flag</th>
                    <th>Range</th>
                    <th>SI Unit</th>
                    <th>Comment</th>
                  </thead>
                  <tbody>
                    <tr v-for="(parameter, p) in SingleResult[0].resultoptions" :key="p">
                      <td>
                        {{ parameter.option_name }}
                      </td>
                      <td>
                        <strong>{{ parameter.result_value }} </strong>
                      </td>
                      <td>
                        <strong>{{ parameter.flag }}</strong>
                      </td>
                      <td v-html="parameter.range"></td>
                      <td>
                        <span v-html="parameter.unit"></span>
                      </td>
                      <td>
                        {{ parameter.comment }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="SingleResult[0].comment">
                  <p style="font-size: 13px">Comments: <span v-html="SingleResult[0].comment"></span></p>
                </div>
                <div style="font-size: 11px">
                  <p>
                    Performed By:
                    <strong>{{ SingleResult[0].technician }}</strong>
                    Result Entry Date:
                    <strong>{{ SingleResult[0].result_date }}</strong>
                  </p>
                  <p v-if="SingleResult[0].reviewer">
                    Reviewed By:
                    <strong>{{ SingleResult[0].reviewer }}</strong>
                    Date Reviewed:
                    <strong>{{ SingleResult[0].review_date }}</strong>
                  </p>
                </div>
                <!--                <hr />-->
                <div>
                  <div style="text-align: center; font-size: 11px">
                    <p>
                      Report Printed by <b>{{ SingleResult[0].printuser }}</b> via Clinic
                      Plus Hospital Software
                    </p>
                  </div>
                </div>
                <div class="image" v-if="SingleResult[0].clinic_stamp">
                  <img :src="SingleResult[0].clinic_stamp" alt="stamp" />
                  <div class="stamp_date">{{ SingleResult[0].date }}</div>
                </div>
              </div>
              <div style="font-size: 12px" v-else-if="SingleResult[0].result_type == 5">
                <p v-if="SingleResult[0].samples.length">Test Samples</p>
                <table class="table" v-if="SingleResult[0].samples.length">
                  <thead>
                    <tr>
                      <th>SAMPLE TYPE</th>
                      <th>DATE COLLECTED</th>
                      <th>DATE RECEIVED</th>
                      <th>TEST REQUESTED</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sample, s) in SingleResult[0].samples" :key="s">
                      <td>{{ sample.sample_name }}</td>
                      <td>{{ sample.pick_time }}</td>
                      <td>{{ sample.receive_time }}</td>
                      <td>{{ sample.test_name }}</td>
                    </tr>
                  </tbody>
                </table>
                <!--                <hr />-->
                <p style="font-size: 13px">Test Results</p>
                <table class="table">
                  <thead>
                    <tr style="border: 1px solid #ddd">
                      <th style="border: 1px solid #ddd">ORGANISM(S) ISOLATED</th>
                      <th style="border: 1px solid #ddd">ANTIBIOTIC(S)</th>
                    </tr>
                  </thead>
                  <tr
                    style="border: 1px solid #ddd"
                    v-for="(parameter, p) in SingleResult[0].resultoptions"
                    :key="p"
                  >
                    <td style="border: 1px solid #ddd">
                      <strong>{{ parameter.option_name }} </strong>
                    </td>
                    <td>
                      <table class="table table-borderless">
                        <tbody>
                          <tr v-for="(antibio, ant) in parameter.result_codes" :key="ant">
                            <td>
                              {{ antibio.antibiotic }}
                            </td>
                            <td>
                              {{ antibio.zone }}
                            </td>
                            <td>
                              {{ antibio.result }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
                <div v-if="SingleResult[0].comment">
                  <p style="font-size: 12px">Comments:</p>
                  <article v-html="SingleResult[0].comment"></article>
                </div>
                <div style="font-size: 11px">
                  <p>
                    Performed By:
                    <strong>{{ SingleResult[0].technician }}</strong>
                    Result Entry Date:
                    <strong>{{ SingleResult[0].result_date }}</strong>
                  </p>
                  <p v-if="SingleResult[0].reviewer">
                    Reviewed By:
                    <strong>{{ SingleResult[0].reviewer }}</strong>
                    Date Reviewed:
                    <strong>{{ SingleResult[0].review_date }}</strong>
                  </p>
                </div>
                <!-- <hr />-->
                <div>
                  <div
                    style="text-align: center; font-size: 11px"
                    v-if="SingleResult[0].branding_settings == 1"
                  >
                    <p>
                      Report Printed by <b>{{ SingleResult[0].printuser }}</b> via Clinic
                      Plus Hospital Software
                    </p>
                  </div>
                </div>
                <div class="image" v-if="SingleResult[0].clinic_stamp">
                  <img :src="SingleResult[0].clinic_stamp" alt="stamp" />
                  <div class="stamp_date">{{ SingleResult[0].date }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  page: {
    title: "Results Reviewing Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Laboratory Results",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Results Report",
          active: true,
        },
      ],
      toPrint: this.$route.params,
      isLoadingmessage: false
    };
  },

  computed: {
    ...mapGetters("reports", ["SingleResult", "SingleEmailStatus", "SingleEmailMsg"]),
  },
  methods: {
    print_repo() {
      window.print();
      this.$router.go(-1);
    },

    ...mapActions({
      FetchResult: "reports/fetchSingleResult",
      EmailSingleResult: "reports/emailSingleResult",
    }),
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    sendReportEmail() {
      this.EmailSingleResult(this.toPrint);
    },

    sendWhatsApp(){
      this.isLoadingmessage = true
      axios.get(`single/${this.$route.params.visit}/${this.$route.params.test}`)
        .then((response) => {
          this.isLoadingmessage = false
          alert(response.data.message);
        })
        .catch((error) => {
          this.isLoadingmessage = false
          alert('Something wrong happened. Messages was not sent')
          console.log(error);// eslint-disable-line no-console
        });
    }
  },

  created() {
    this.FetchResult(this.toPrint);
  },
};
</script>

<style lang="css" scoped>
tr,
td {
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 11px;
}
body {
  padding-top: 0px;
  padding-bottom: 0px;
}

.image {
  left: 100vw;
}
.image img {
  width: 180px;
}

.stamp_date {
  position: relative;
  color: red !important;
  font-size: 20px !important;
  top: -68px;
  left: 5%;
}
.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
hr {
  height: 1px;
  border-width: 0;
  color: gray;
  background-color: gray;
}
</style>
